import React from 'react';

export const onServiceWorkerUpdateReady = () => window.location.reload(true);
